/**
 * @flow
 * @relayHash ccbdf608acb91acbba6c8a32888fe024
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateOrderModal_order$ref = any;
type DeleteOrderModal_order$ref = any;
type OrderDetails_defaultForm$ref = any;
type OrderDetails_order$ref = any;
type OrderJobTickets_jobEdges$ref = any;
type OrderJobTickets_order$ref = any;
type OrderJobTickets_workflowEdges$ref = any;
type OrderSidePanel_order$ref = any;
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type OrderQueryVariables = {|
  id: string,
  orderIds: $ReadOnlyArray<string>,
|};
export type OrderQueryResponse = {|
  +order: {|
    +id: string,
    +orderNumber: string,
    +customerOrderNumber: ?string,
    +status: OrderStatus,
    +notes: ?string,
    +currency: ?string,
    +subtotal: ?number,
    +discountPercent: ?number,
    +discountAmount: ?number,
    +taxRate: ?number,
    +taxAmount: ?number,
    +totalAmount: ?number,
    +orderedAt: ?any,
    +promisedAt: ?any,
    +requiredAt: ?any,
    +createdAt: any,
    +shippingAddressLine1: ?string,
    +shippingAddressLine2: ?string,
    +shippingAddressLine3: ?string,
    +shippingAddressCity: ?string,
    +shippingAddressState: ?string,
    +shippingAddressZip: ?string,
    +yields: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: {|
          +id: string,
          +orderedQuantity: number,
          +unitPrice: ?number,
          +discountPercent: ?number,
          +lineTotal: ?number,
          +item: {|
            +id: string,
            +name: string,
            +itemNumber: string,
            +description: ?string,
            +quantityUOM: {|
              +id: string,
              +symbol: string,
            |},
          |},
        |}
      |}>
    |},
    +customer: {|
      +id: string,
      +name: string,
      +email: ?any,
      +phone: ?string,
      +billingAddressLine1: ?string,
      +billingAddressLine2: ?string,
      +billingAddressLine3: ?string,
      +billingAddressCity: ?string,
      +billingAddressState: ?string,
      +billingAddressZip: ?string,
    |},
    +$fragmentRefs: OrderSidePanel_order$ref & OrderDetails_order$ref & AddUpdateOrderModal_order$ref & DeleteOrderModal_order$ref & OrderJobTickets_order$ref,
  |},
  +jobs: {|
    +edges: ?$ReadOnlyArray<?{|
      +$fragmentRefs: OrderJobTickets_jobEdges$ref
    |}>
  |},
  +workflows: {|
    +edges: ?$ReadOnlyArray<?{|
      +$fragmentRefs: OrderJobTickets_workflowEdges$ref
    |}>
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string,
      +name: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
    |},
  |},
  +forms: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +type: FormType,
        +$fragmentRefs: OrderDetails_defaultForm$ref,
      |}
    |}>
  |},
|};
export type OrderQuery = {|
  variables: OrderQueryVariables,
  response: OrderQueryResponse,
|};
*/


/*
query OrderQuery(
  $id: ID!
  $orderIds: [ID!]!
) {
  order(id: $id) {
    id
    orderNumber
    customerOrderNumber
    status
    notes
    currency
    subtotal
    discountPercent
    discountAmount
    taxRate
    taxAmount
    totalAmount
    orderedAt
    promisedAt
    requiredAt
    createdAt
    shippingAddressLine1
    shippingAddressLine2
    shippingAddressLine3
    shippingAddressCity
    shippingAddressState
    shippingAddressZip
    yields {
      edges {
        node {
          id
          orderedQuantity
          unitPrice
          discountPercent
          lineTotal
          item {
            id
            name
            itemNumber
            description
            quantityUOM {
              id
              symbol
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    customer {
      id
      name
      email
      phone
      billingAddressLine1
      billingAddressLine2
      billingAddressLine3
      billingAddressCity
      billingAddressState
      billingAddressZip
    }
    ...OrderSidePanel_order
    ...OrderDetails_order
    ...AddUpdateOrderModal_order
    ...DeleteOrderModal_order
    ...OrderJobTickets_order
  }
  jobs(orderIds: $orderIds) {
    edges {
      ...OrderJobTickets_jobEdges
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workflows {
    edges {
      ...OrderJobTickets_workflowEdges
    }
  }
  viewer {
    id
    permissions
    company {
      id
      name
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
    }
  }
  forms(types: [ITEM]) {
    edges {
      node {
        id
        type
        ...OrderDetails_defaultForm
      }
    }
  }
}

fragment OrderSidePanel_order on Order {
  id
  customerOrderNumber
  shippingAddressLine1
  shippingAddressLine2
  shippingAddressLine3
  shippingAddressCity
  shippingAddressState
  shippingAddressZip
  notes
  orderedAt
  promisedAt
  requiredAt
  user {
    ...UserWidget_user
    id
  }
}

fragment OrderDetails_order on Order {
  id
  yields {
    edges {
      ...OrderYieldPanels_orderYieldEdges
      ...AddUpdateOrderYieldModal_orderYieldEdges
      node {
        id
        order {
          id
        }
        orderedQuantity
        item {
          id
          name
          description
          ...AddUpdateItemModal_item
        }
        ...AddUpdateOrderYieldModal_orderYield
        ...DeleteOrderYieldModal_orderYield
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  orderNumber
  customerOrderNumber
  orderedAt
  promisedAt
  requiredAt
}

fragment AddUpdateOrderModal_order on Order {
  id
  customerOrderNumber
  shippingAddressLine1
  shippingAddressLine2
  shippingAddressLine3
  shippingAddressCity
  shippingAddressState
  shippingAddressZip
  notes
  orderedAt
  requiredAt
  promisedAt
  customer {
    id
    name
  }
  user {
    id
    firstName
    lastName
  }
}

fragment DeleteOrderModal_order on Order {
  id
  orderNumber
}

fragment OrderJobTickets_order on Order {
  id
}

fragment OrderJobTickets_jobEdges on JobEdge {
  ...JobsTable_jobEdges
}

fragment OrderJobTickets_workflowEdges on WorkflowEdge {
  node {
    id
    isDefault
    ...AddUpdateJobModal_workflow
  }
}

fragment OrderDetails_defaultForm on Form {
  id
  ...AddUpdateItemModal_defaultForm
}

fragment AddUpdateItemModal_defaultForm on Form {
  id
  type
  name
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment AddUpdateJobModal_workflow on Workflow {
  id
  name
  states {
    id
    isGangRun
  }
}

fragment JobsTable_jobEdges on JobEdge {
  node {
    id
    jobNumber
    importJobNumber
    name
    status
    createdAt
    user {
      id
      ...UserAvatar_user
    }
    yields {
      totalCount
    }
    order {
      id
      promisedAt
      customer {
        id
        name
      }
    }
    states {
      id
      isEnabled
      status
      workflowState {
        id
        name
        type
      }
    }
    workflow {
      id
      states {
        id
        name
        isRequired
        type
      }
      transitions {
        id
        toWorkflowState {
          id
        }
        fromWorkflowState {
          id
        }
      }
    }
    ...AddUpdateJobModal_job
    ...DeleteJobModal_job
  }
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment AddUpdateJobModal_job on Job {
  id
  name
  notes
  user {
    id
  }
  workflow {
    id
    name
    states {
      id
      isGangRun
    }
  }
  order {
    id
  }
  yields {
    edges {
      node {
        id
        quantity
        itemNumberUp
        brokerCustomerOrderNumber
        formFieldValues
        overUnderRule
        overQuantity
        item {
          id
          name
          quantityUOM {
            id
            name
            symbol
          }
        }
      }
    }
  }
}

fragment DeleteJobModal_job on Job {
  id
  name
  order {
    id
  }
}

fragment OrderYieldPanels_orderYieldEdges on OrderYieldEdge {
  node {
    id
    orderedQuantity
    order {
      id
    }
    item {
      id
      itemNumber
      name
      description
      partNumber
      formFieldValues
      quantityUOM {
        id
        symbol
      }
    }
    ...AddUpdateOrderYieldModal_orderYield
    ...DeleteOrderYieldModal_orderYield
  }
}

fragment AddUpdateOrderYieldModal_orderYieldEdges on OrderYieldEdge {
  node {
    id
    item {
      id
    }
  }
}

fragment AddUpdateItemModal_item on Item {
  id
  name
  upc
  partNumber
  bomNumber
  description
  category {
    id
    name
  }
  quantityUOM {
    id
    name
    type
    symbol
  }
  weightUOM {
    id
    name
    type
    symbol
  }
  dimensionUOM {
    id
    name
    type
    symbol
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
      ...AdditionalFieldInfo_formField
    }
  }
  formFieldValues
  dimensionLength
  dimensionWidth
  dimensionHeight
  weight
  lotTracking
  cost
  sellingPrice
  safetyQuantity
  totalValue
  defaultLocation {
    id
    name
  }
}

fragment AddUpdateOrderYieldModal_orderYield on OrderYield {
  id
  order {
    id
  }
  orderedQuantity
  unitPrice
  item {
    id
    name
    quantityUOM {
      id
      name
      symbol
    }
  }
}

fragment DeleteOrderYieldModal_orderYield on OrderYield {
  id
  item {
    id
    name
  }
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}

fragment UserWidget_user on User {
  id
  firstName
  lastName
  ...UserAvatar_user
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customerOrderNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtotal",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discountPercent",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discountAmount",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "taxRate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "taxAmount",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAmount",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderedAt",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promisedAt",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "requiredAt",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine1",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine2",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine3",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressCity",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressState",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressZip",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderedQuantity",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "unitPrice",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lineTotal",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v27/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    (v34/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressLine1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressLine2",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressLine3",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressCity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressState",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "billingAddressZip",
      "args": null,
      "storageKey": null
    }
  ]
},
v36 = [
  {
    "kind": "Variable",
    "name": "orderIds",
    "variableName": "orderIds"
  }
],
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressLine1",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressLine2",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressCity",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressState",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressZip",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "addressCountry",
          "args": null,
          "storageKey": null
        },
        (v34/*: any*/)
      ]
    }
  ]
},
v38 = [
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "ITEM"
    ]
  }
],
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "formFieldValues",
  "args": null,
  "storageKey": null
},
v41 = [
  (v2/*: any*/),
  (v27/*: any*/)
],
v42 = [
  (v2/*: any*/),
  (v27/*: any*/),
  (v39/*: any*/),
  (v30/*: any*/)
],
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
},
v44 = [
  (v2/*: any*/)
],
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productionType",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductionType",
  "plural": false,
  "selections": (v44/*: any*/)
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isRequired",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "fields",
  "storageKey": null,
  "args": null,
  "concreteType": "FormField",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v43/*: any*/),
    (v39/*: any*/),
    (v27/*: any*/),
    (v29/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    (v46/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCreatable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "applicationType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "properties",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "options",
      "storageKey": null,
      "args": null,
      "concreteType": "FormFieldOption",
      "plural": true,
      "selections": [
        (v27/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/)
      ]
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avatar",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isGangRun",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "OrderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "yields",
            "name": "__Order_yields_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OrderYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderYield",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v9/*: any*/),
                      (v26/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "quantityUOM",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UOM",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v30/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v31/*: any*/)
                    ]
                  },
                  (v32/*: any*/)
                ]
              },
              (v33/*: any*/)
            ]
          },
          (v35/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "OrderSidePanel_order",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "OrderDetails_order",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AddUpdateOrderModal_order",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DeleteOrderModal_order",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "OrderJobTickets_order",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "jobs",
        "name": "__Order_jobs_connection",
        "storageKey": null,
        "args": (v36/*: any*/),
        "concreteType": "JobConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": true,
            "selections": [
              (v32/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v31/*: any*/)
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "OrderJobTickets_jobEdges",
                "args": null
              }
            ]
          },
          (v33/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "workflows",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkflowConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkflowEdge",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "OrderJobTickets_workflowEdges",
                "args": null
              }
            ]
          }
        ]
      },
      (v37/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v38/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v39/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "OrderDetails_defaultForm",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OrderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "yields",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OrderYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderYield",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v9/*: any*/),
                      (v26/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "quantityUOM",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UOM",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v30/*: any*/),
                              (v27/*: any*/),
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "partNumber",
                            "args": null,
                            "storageKey": null
                          },
                          (v40/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "upc",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "bomNumber",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemCategory",
                            "plural": false,
                            "selections": (v41/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "weightUOM",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UOM",
                            "plural": false,
                            "selections": (v42/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "dimensionUOM",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UOM",
                            "plural": false,
                            "selections": (v42/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "form",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Form",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v27/*: any*/),
                              (v39/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v47/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dimensionLength",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dimensionWidth",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dimensionHeight",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "weight",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lotTracking",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cost",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sellingPrice",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "safetyQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalValue",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "defaultLocation",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WarehouseLocation",
                            "plural": false,
                            "selections": (v41/*: any*/)
                          }
                        ]
                      },
                      (v31/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "order",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Order",
                        "plural": false,
                        "selections": (v44/*: any*/)
                      }
                    ]
                  },
                  (v32/*: any*/)
                ]
              },
              (v33/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "Order_yields",
            "filters": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "yields",
            "args": null,
            "handle": "connection",
            "key": "OrderDetails_order_yields",
            "filters": []
          },
          (v35/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v48/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              (v49/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "jobs",
        "storageKey": null,
        "args": (v36/*: any*/),
        "concreteType": "JobConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "JobEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "jobNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "importJobNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  (v5/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v49/*: any*/),
                      (v48/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "yields",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYieldEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "JobYield",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumberUp",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "brokerCustomerOrderNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v40/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overUnderRule",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "overQuantity",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "quantityUOM",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UOM",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v27/*: any*/),
                                      (v30/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "customer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Customer",
                        "plural": false,
                        "selections": (v41/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isEnabled",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "workflowState",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v27/*: any*/),
                          (v39/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflow",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Workflow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowState",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v50/*: any*/),
                          (v27/*: any*/),
                          (v46/*: any*/),
                          (v39/*: any*/)
                        ]
                      },
                      (v27/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transitions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WorkflowTransition",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "toWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v44/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "fromWorkflowState",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WorkflowState",
                            "plural": false,
                            "selections": (v44/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/),
                  (v31/*: any*/)
                ]
              },
              (v32/*: any*/)
            ]
          },
          (v33/*: any*/)
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "jobs",
        "args": (v36/*: any*/),
        "handle": "connection",
        "key": "Order_jobs",
        "filters": [
          "orderIds"
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "workflows",
        "storageKey": null,
        "args": null,
        "concreteType": "WorkflowConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WorkflowEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Workflow",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDefault",
                    "args": null,
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "states",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkflowState",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v50/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v37/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v38/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v39/*: any*/),
                  (v27/*: any*/),
                  (v43/*: any*/),
                  (v45/*: any*/),
                  (v47/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "OrderQuery",
    "id": null,
    "text": "query OrderQuery(\n  $id: ID!\n  $orderIds: [ID!]!\n) {\n  order(id: $id) {\n    id\n    orderNumber\n    customerOrderNumber\n    status\n    notes\n    currency\n    subtotal\n    discountPercent\n    discountAmount\n    taxRate\n    taxAmount\n    totalAmount\n    orderedAt\n    promisedAt\n    requiredAt\n    createdAt\n    shippingAddressLine1\n    shippingAddressLine2\n    shippingAddressLine3\n    shippingAddressCity\n    shippingAddressState\n    shippingAddressZip\n    yields {\n      edges {\n        node {\n          id\n          orderedQuantity\n          unitPrice\n          discountPercent\n          lineTotal\n          item {\n            id\n            name\n            itemNumber\n            description\n            quantityUOM {\n              id\n              symbol\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    customer {\n      id\n      name\n      email\n      phone\n      billingAddressLine1\n      billingAddressLine2\n      billingAddressLine3\n      billingAddressCity\n      billingAddressState\n      billingAddressZip\n    }\n    ...OrderSidePanel_order\n    ...OrderDetails_order\n    ...AddUpdateOrderModal_order\n    ...DeleteOrderModal_order\n    ...OrderJobTickets_order\n  }\n  jobs(orderIds: $orderIds) {\n    edges {\n      ...OrderJobTickets_jobEdges\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workflows {\n    edges {\n      ...OrderJobTickets_workflowEdges\n    }\n  }\n  viewer {\n    id\n    permissions\n    company {\n      id\n      name\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n    }\n  }\n  forms(types: [ITEM]) {\n    edges {\n      node {\n        id\n        type\n        ...OrderDetails_defaultForm\n      }\n    }\n  }\n}\n\nfragment OrderSidePanel_order on Order {\n  id\n  customerOrderNumber\n  shippingAddressLine1\n  shippingAddressLine2\n  shippingAddressLine3\n  shippingAddressCity\n  shippingAddressState\n  shippingAddressZip\n  notes\n  orderedAt\n  promisedAt\n  requiredAt\n  user {\n    ...UserWidget_user\n    id\n  }\n}\n\nfragment OrderDetails_order on Order {\n  id\n  yields {\n    edges {\n      ...OrderYieldPanels_orderYieldEdges\n      ...AddUpdateOrderYieldModal_orderYieldEdges\n      node {\n        id\n        order {\n          id\n        }\n        orderedQuantity\n        item {\n          id\n          name\n          description\n          ...AddUpdateItemModal_item\n        }\n        ...AddUpdateOrderYieldModal_orderYield\n        ...DeleteOrderYieldModal_orderYield\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  orderNumber\n  customerOrderNumber\n  orderedAt\n  promisedAt\n  requiredAt\n}\n\nfragment AddUpdateOrderModal_order on Order {\n  id\n  customerOrderNumber\n  shippingAddressLine1\n  shippingAddressLine2\n  shippingAddressLine3\n  shippingAddressCity\n  shippingAddressState\n  shippingAddressZip\n  notes\n  orderedAt\n  requiredAt\n  promisedAt\n  customer {\n    id\n    name\n  }\n  user {\n    id\n    firstName\n    lastName\n  }\n}\n\nfragment DeleteOrderModal_order on Order {\n  id\n  orderNumber\n}\n\nfragment OrderJobTickets_order on Order {\n  id\n}\n\nfragment OrderJobTickets_jobEdges on JobEdge {\n  ...JobsTable_jobEdges\n}\n\nfragment OrderJobTickets_workflowEdges on WorkflowEdge {\n  node {\n    id\n    isDefault\n    ...AddUpdateJobModal_workflow\n  }\n}\n\nfragment OrderDetails_defaultForm on Form {\n  id\n  ...AddUpdateItemModal_defaultForm\n}\n\nfragment AddUpdateItemModal_defaultForm on Form {\n  id\n  type\n  name\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment AddUpdateJobModal_workflow on Workflow {\n  id\n  name\n  states {\n    id\n    isGangRun\n  }\n}\n\nfragment JobsTable_jobEdges on JobEdge {\n  node {\n    id\n    jobNumber\n    importJobNumber\n    name\n    status\n    createdAt\n    user {\n      id\n      ...UserAvatar_user\n    }\n    yields {\n      totalCount\n    }\n    order {\n      id\n      promisedAt\n      customer {\n        id\n        name\n      }\n    }\n    states {\n      id\n      isEnabled\n      status\n      workflowState {\n        id\n        name\n        type\n      }\n    }\n    workflow {\n      id\n      states {\n        id\n        name\n        isRequired\n        type\n      }\n      transitions {\n        id\n        toWorkflowState {\n          id\n        }\n        fromWorkflowState {\n          id\n        }\n      }\n    }\n    ...AddUpdateJobModal_job\n    ...DeleteJobModal_job\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment AddUpdateJobModal_job on Job {\n  id\n  name\n  notes\n  user {\n    id\n  }\n  workflow {\n    id\n    name\n    states {\n      id\n      isGangRun\n    }\n  }\n  order {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        itemNumberUp\n        brokerCustomerOrderNumber\n        formFieldValues\n        overUnderRule\n        overQuantity\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            name\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteJobModal_job on Job {\n  id\n  name\n  order {\n    id\n  }\n}\n\nfragment OrderYieldPanels_orderYieldEdges on OrderYieldEdge {\n  node {\n    id\n    orderedQuantity\n    order {\n      id\n    }\n    item {\n      id\n      itemNumber\n      name\n      description\n      partNumber\n      formFieldValues\n      quantityUOM {\n        id\n        symbol\n      }\n    }\n    ...AddUpdateOrderYieldModal_orderYield\n    ...DeleteOrderYieldModal_orderYield\n  }\n}\n\nfragment AddUpdateOrderYieldModal_orderYieldEdges on OrderYieldEdge {\n  node {\n    id\n    item {\n      id\n    }\n  }\n}\n\nfragment AddUpdateItemModal_item on Item {\n  id\n  name\n  upc\n  partNumber\n  bomNumber\n  description\n  category {\n    id\n    name\n  }\n  quantityUOM {\n    id\n    name\n    type\n    symbol\n  }\n  weightUOM {\n    id\n    name\n    type\n    symbol\n  }\n  dimensionUOM {\n    id\n    name\n    type\n    symbol\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n      ...AdditionalFieldInfo_formField\n    }\n  }\n  formFieldValues\n  dimensionLength\n  dimensionWidth\n  dimensionHeight\n  weight\n  lotTracking\n  cost\n  sellingPrice\n  safetyQuantity\n  totalValue\n  defaultLocation {\n    id\n    name\n  }\n}\n\nfragment AddUpdateOrderYieldModal_orderYield on OrderYield {\n  id\n  order {\n    id\n  }\n  orderedQuantity\n  unitPrice\n  item {\n    id\n    name\n    quantityUOM {\n      id\n      name\n      symbol\n    }\n  }\n}\n\nfragment DeleteOrderYieldModal_orderYield on OrderYield {\n  id\n  item {\n    id\n    name\n  }\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment UserWidget_user on User {\n  id\n  firstName\n  lastName\n  ...UserAvatar_user\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "order",
            "yields"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "jobs"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e8a20b5b80859dad2327f0ab1ade7a61';
module.exports = node;
